import _ from "lodash";
import { AppConstant } from "src/app/shared/constants/app.constant";
import * as moment from "moment";
import { SelectList } from "../models/select-list";
export class Helper {
  public static isEmpty(s) {
    return _.isEmpty(s);
  }

  // public static getPostcodePattern(iso: string): string {
  //   const o = _.find(AppConstant.POSTALCODE, (x) => {
  //     return x['ISO'] === iso;
  //   });
  //   return o['Regex'];
  // }

  public static getPostcodePatterns(countryId: string): string {
    const patern = _.find(AppConstant.POSTALCODE, (o) => {
      return countryId === o.id;
    });
    if (_.isUndefined(patern)) {
      return null;
    } else {
      return patern.reg;
    }
  }

  public static getStart(page, limit) {
    return (page - 1) * limit;
  }

  public static getDateStr(dt: Date) {
    let s = `${dt.getFullYear()}-${this.paddZero(
      dt.getMonth() + 1
    )}-${Helper.paddZero(dt.getDate())}`;
    return s;
  }

  public static getDateStr1(dt: Date) {
    let s = `${dt.getFullYear()}${this.paddZero(
      dt.getMonth() + 1
    )}${Helper.paddZero(dt.getDate())}`;
    return s;
  }

  public static paddZero(i: number) {
    let s = `${i}`;
    if (i < 10) {
      s = `0${i}`;
    }

    return s;
  }

  public static replaceNone(s: string) {
    let r = s;
    if (_.isNull(s)) return s;

    if (s.toLowerCase() === "none") {
      r = "";
    }

    return r;
  }

  public static formatAmount(x: string) {
    let s = parseFloat(x);
    return s.toFixed(2);
  }

  public static getUser() {
    let user = JSON.parse(localStorage.getItem("user"));
    return user;
  }

  public static getUserObject(obj) {
    if (Helper.isEmpty(obj)) {
      return null;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    return _.get(user, obj, null);
  }

  public static get getSelectedBusiness(): {
    businessName: string;
    businessId: string;
    selected: boolean;
  } {
    const selectedBusiness = JSON.parse(
      localStorage.getItem("selected_business")
    ) || {
      businessId: null,
      businessName: null,
      selected: false,
    };
    return {
      businessId: selectedBusiness.businessId,
      businessName: selectedBusiness.businessName,
      selected: selectedBusiness.selected,
    }
  }

  public static setSelectedBusiness({businessName,businessId,selected = false}) {
    localStorage.setItem("selected_business", JSON.stringify({businessName,businessId,selected}))
  }

  public static get getBusinessSelectList(): Array<SelectList> {
    return JSON.parse(localStorage.getItem("business_select_list")) || [];
  }
  public static setBusinessSelectList(businesses: Array<SelectList>) {
    const uniqueData = Array.from(
      businesses
        .reduce((map, item) => map.set(item.value, item), new Map())
        .values()
    );
    localStorage.setItem("business_select_list", JSON.stringify(uniqueData));
  }

  public static permissions(prm) {
    const permission = this.getUserObject("permissions");
    let pm = -1;
    if (!Helper.isEmpty(permission)) {
      pm = _.findIndex(permission, (o) => {
        return o === prm;
      });
    }
    return pm;
  }

  public static isReadOnlyPersimission(read, update) {
    if (this.hasPermission(read) && !this.hasPermission(update)) {
      return true;
    }
    return false;
  }

  public static hasPermission(permission): boolean {
    let bl: boolean = false;
    if (permission === "") {
      return bl;
    }
    /**
     * if page or module don't have permisstion validation pass ALL
     */
    if (permission === "ALL") {
      return true;
    }
    if (this.permissions(permission) !== -1) {
      bl = true;
    }
    return bl;
  }

  public static toDecil(amount): string {
    return parseFloat(amount).toFixed(2);
  }

  public static toString(input) {
    !this.isEmpty(input) ? input : "0.00";
    return _.toString(input);
  }

  public static preventToast() {
    localStorage.setItem("preventToast", "true");
  }
  public static isPreventedToast(): boolean {
    return !!localStorage.getItem("preventToast");
  }
  public static clearPreventedToast() {
    localStorage.removeItem("preventToast");
  }

  public static isExistStation(stationid, list) {
    const bzid = _.find(list, (o) => {
      return o.value === stationid;
    });
    if (bzid == undefined) {
      return null;
    }
    return bzid.value;
  }

  public static checkFileType(file) {
    if (!this.isEmpty(file)) {
      return this.findType(this.getFileExtention(file));
    } else {
      return null;
    }
  }

  public static getFileExtention(file): string {
    const [extension, ...nameParts] = file.split(".").reverse();
    return extension;
  }

  private static findType(type) {
    console.log(type);

    type = _.lowerCase(type + "");
    const vaiableFileType = ["pdf", "doc", "docx", "xls", "xlsx", "txt", "csv"];
    const vaiableImageType = ["jpeg", "jpg", "png"];
    const idxOfFile = _.indexOf(vaiableFileType, type);
    const idxOfImg = _.indexOf(vaiableImageType, type);
    if (idxOfFile !== -1) {
      return "FILE";
    } else if (idxOfImg !== -1) {
      return "IMG";
    } else {
      return null;
    }
  }

  public static pageCount(page, pageSize) {
    return ((page * pageSize) - pageSize) + 1;
  }

  public static getAttachmentIcon(path: string): string {
    if (path == null) {
      return 'fas fa-file text-secondary';
    }
    const files = [
      { name: 'excel', icon: 'fa-file-excel text-success' },
      { name: 'xls', icon: 'fa-file-excel text-success' },
      { name: 'xlsx', icon: 'fa-file-excel text-success' },
      { name: 'csv', icon: 'fa-file-excel text-success' },
      { name: 'pdf', icon: 'fa-file-pdf text-danger' },
      { name: 'doc', icon: 'fa-file-word text-primary' },
      { name: 'docx', icon: 'fa-file-word text-primary' },
      { name: 'txt', icon: 'fa-file text-secondary' },
      { name: 'jpg', icon: 'fa-file-image text-gray' },
      { name: 'jpeg', icon: 'fa-file-image text-gray' },
      { name: 'png', icon: 'fa-file-image text-gray' },
    ]

    const extension = Helper.getFileExtention(path);
    const icon = _.find(files, (o) => o.name == extension);
    return `fas ${icon ? icon.icon : 'fa-file text-secondary'} fa-2x`;
  }

  public static isValidData(mydate) {
    if (mydate == null && mydate != AppConstant.INVALID_DATE_TEXT) {
      return false;
    }
    if (
      AppConstant.VALIDATE.DB_DATE_FORMATE.test(Helper.getDateStr(mydate) + "")
    ) {
      return true;
    }
    return false;
  }

  public static getMomentDate(myDate) {
    if (myDate == null) {
      myDate = new Date();
    }
    return moment(myDate).format("yyyy-MM-DD");
  }

  public static getMomentDateTime(myDateTime) {
    if (myDateTime == null) {
      myDateTime = new Date();
    }
    return moment(myDateTime).format("yyyy-MM-DD hh:mm:ss");
  }

  public static isFMXUser(): boolean {
    return this.getUserObject("businessId") === "FMX";
  }

  public static get isActiveBusiness(): boolean {
    const businessDetails = localStorage.getItem("business-details");
    if (businessDetails) {
      const { businessStatus } = JSON.parse(businessDetails);
      return businessStatus == "Active";
    }
    return false;
  }

  public static getFileName(type, id) {
    const d = new Date();
    if (type != null) {
      return `${id}-${d.getFullYear()}${d.getMonth()}${d.getDay()}${d.getHours()}${d.getMinutes()}${d.getSeconds()}.${type}`;
    }
    return `${id}-${d.getFullYear()}${d.getMonth()}${d.getDay()}${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;
  }
}
